<template>
    <div class="slidelist">

        <div class="slidelist-left"
             :style="{width: fwidth}"
        >
            <table class="table">
                <thead>
                <tr>
                    <th class="border-bottom">
                        <span v-if="!sortInfo.field">证券简称</span>
                        <button v-else
                                @click="cancelSort"
                                class="btn-sort-cancel">取消排序
                        </button>
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index)  in tableData"
                    :class="{active: item.secCode === secCode}"
                    :key="index">
                    <td class="border-bottom"
                        @click="toCompany(item)">
                        <span class="sec-name">{{item.secSname}}</span>
                        <br>
                        <span class="sec-code">{{item.secCode | patchStub}}  <i  v-if="item.isLt === 1" class="top-one">龙头</i></span>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="slidelist-right"
             :style="{marginLeft: fwidth}"
             :class="{blockage}"
             @scroll="viewScroll">
            <table class="table">
                <thead>
                <tr>
                    <th class="border-bottom" :class="{sorting:'totalScore' === sortInfo.field }"
                        @click="sort({field: 'totalScore'})"
                    >财务得分<i :class="sortCalssName(sortInfo, 'totalScore')"></i>
                    </th>

                    <th class="border-bottom" :class="{sorting:'profitIncrease' === sortInfo.field }"
                        @click="sort({field: 'profitIncrease'})"
                    >归母净利润增速<i :class="sortCalssName(sortInfo, 'profitIncrease')"></i>
                    </th>

                    <th class="border-bottom" :class="{sorting:'revIncrease' === sortInfo.field }"
                        @click="sort({field: 'revIncrease'})"
                    >总营收增速<i :class="sortCalssName(sortInfo, 'revIncrease')"></i>
                    </th>

                    <th class="border-bottom"
                        :class="{sorting:'labelRank' === sortInfo.field }"
                        @click="sort({field: 'labelRank'})"
                    >20日股价走势<i :class="sortCalssName(sortInfo, 'labelRank')"></i></th>
                </tr>

                </thead>
                <tbody>
                <tr v-for="(item, index)  in tableData"
                    :class="{active: item.secCode === secCode}"
                    :key="index">
                    <td class="border-bottom" :class="LabelColor(item.evaluation)">{{item.totalScore | keep2Decimals |
                        patchStub}}
                    </td>
                    <td class="border-bottom">{{item.profitIncreaseDisplay | patchStub}}{{item.profitIncreaseUnit}}</td>
                    <td class="border-bottom">{{item.revIncreaseDisplay | patchStub}}{{item.revIncreaseUnit}}</td>
                    <td class="border-bottom img"><span
                            @click="open(item)"
                            :class="{green: item.labelType == '2', red: item.labelType == '1'}">{{item.trendLabel20d | patchStub}}</span>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <p class="no-data" v-if="tableData.length ===0">暂无数据</p>
    </div>
</template>
<script>
    import {LabelColor} from "../../assets/js/evaluation";
    import {OpenQuoteDetail} from "../../assets/choice";


    export default {
        props: [
            'tableData',
            "sortInfo",
            "secCode",
        ],
        data() {
            return {
                fwidth: '2rem',
                blockage: true
            }
        },

        methods: {
            sortCalssName(sortInfo, field) {
                let className = `triangle triangle-left-right `;
                if (field === sortInfo.field) {
                    className = `icon-sort icon-sort-${sortInfo.order}`
                }
                return className
            },
            LabelColor,
            sort(query) {
                let order = "desc";
                if (this.sortInfo.field === query.field) {
                    if (this.sortInfo.order === 'desc') {
                        order = 'asc'
                    }
                }

                this.$emit('sort', {
                    field: query.field,
                    order,
                })
            },
            cancelSort() {
                this.$emit('sort', {field: '', order: '',})
            },
            toCompany(item) {
                this.$router.push({
                    path: "/company",
                    query: {
                        code: item.secCode
                    }
                });
            },
            viewScroll(e) {
                let diff = 10;
                let {scrollWidth, scrollLeft, clientWidth} = e.currentTarget;
                let scrollRight = scrollWidth - clientWidth - scrollLeft;
                if (scrollRight <= diff) {
                    this.blockage = false
                } else {
                    this.blockage = true
                }
            },
            open(item) {
                OpenQuoteDetail({
                    secuCode: item.emSecCode,
                    secuName: item.secSname,
                    marketType: item.marketType
                })
            }
        }
    }
</script>